export function buildChartSummaryHtml(caption, rows, options = {}) {
  const formatter = typeof options.formatValue === 'function'
    ? options.formatValue
    : value => String(Number(value || 0));

  const visibleRows = (rows || [])
    .map(([label, value]) => [label, Number(value || 0)])
    .filter(([, value]) => value > 0);

  if (!visibleRows.length) {
    return '<p class="pn-chart-summary-empty">Sem dados de perfil disponíveis.</p>';
  }

  return `
    <table>
      <caption>${escapeHtml(caption)}</caption>
      <tbody>
        ${visibleRows.map(([label, value]) => `
          <tr>
            <th scope="row">${escapeHtml(label)}</th>
            <td>${escapeHtml(formatter(value))}</td>
          </tr>
        `).join('')}
      </tbody>
    </table>
  `;
}

export function syncCanvasAccessibility(canvas, summary, caption) {
  if (!canvas || !summary) return;
  canvas.setAttribute('role', 'img');
  canvas.setAttribute('aria-label', caption);
  canvas.setAttribute('aria-describedby', summary.id);
  summary.setAttribute('aria-live', 'polite');
}

function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
